import React, { useState, useEffect } from 'react';
import { getTokenHolders, HolderData } from '../services/holderService';

const PlainHolders: React.FC = () => {
  const [holders, setHolders] = useState<HolderData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchHolders();
  }, []);

  const fetchHolders = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const allHolders = await getTokenHolders();
      setHolders(allHolders);
    } catch (err) {
      console.error('Error fetching holders:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch token holders');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Generate the plain text output without rank/index and headings
  const plainTextOutput = holders.map((holder) => 
    `${holder.address},${holder.proportionOf100k.toFixed(2)}`
  ).join('\n');

  return (
    <div>
      <h1>VOOVO Token - 100K Distribution</h1>
      <button onClick={fetchHolders}>Refresh Data</button>
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        {plainTextOutput}
      </pre>
    </div>
  );
};

export default PlainHolders; 